export default __webpack_public_path__ + "static/media/background_2.2be5bb2c.png";